import { render, staticRenderFns } from "./EstoqueLista.vue?vue&type=template&id=45262b9e&scoped=true&"
import script from "./EstoqueLista.vue?vue&type=script&lang=js&"
export * from "./EstoqueLista.vue?vue&type=script&lang=js&"
import style0 from "./EstoqueLista.vue?vue&type=style&index=0&id=45262b9e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45262b9e",
  null
  
)

export default component.exports